import type { FormatterArgs } from '@/services/types/formatter';
import { resolveRowMark } from '@/views/formatters/row-mark';

export default ({ data, key }: FormatterArgs) => {
  const html = String(data[key] ?? '');
  const mark = (data.DT_RowMark || data.DT_RowMark === 0) && key.startsWith('reports-custom')
    ? resolveRowMark(data)
    : undefined;

  return { kind: 'marked-html', html, mark };
};
